var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiveTheThumbsUp8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "give-the-thumbs-up-8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.05,
    height: 56.602,
    viewBox: "0 0 58.05 56.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #192a40;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    className: "cls-1",
    d: "M45.071,56.6H6.174A6.181,6.181,0,0,1,0,50.428V28.366c0-3.514,2.892-6.6,6.174-6.6h6.207A13.568,13.568,0,0,0,26.132,7.776V6.149A6.417,6.417,0,0,1,32.484,0h.166a6.2,6.2,0,0,1,5.809,4.182l.4,1.146a20.16,20.16,0,0,1,.474,11.333l-.217.9a9.824,9.824,0,0,1-.871,2.758H51.9a6.058,6.058,0,0,1,4.862,2.462,6.341,6.341,0,0,1,1.048,5.531L51.021,51.99a6.2,6.2,0,0,1-5.95,4.613Zm-38.9-31.93A3.646,3.646,0,0,0,2.9,28.366V50.428A3.281,3.281,0,0,0,6.174,53.7h38.9a3.34,3.34,0,0,0,3.17-2.491L55.026,27.5a3.337,3.337,0,0,0-.575-2.979,3.167,3.167,0,0,0-2.541-1.3H34.833V20.316a7.115,7.115,0,0,0,1.4-3.022l.04-.3.242-1.019a17.334,17.334,0,0,0-.38-9.7l-.419-1.146A3.333,3.333,0,0,0,32.65,2.9h-.166a3.535,3.535,0,0,0-3.452,3.25V7.776c0,9.634-7.161,16.9-16.65,16.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    className: "cls-1",
    d: "M207.018,443.066a1.446,1.446,0,0,1-1.45-1.446V412.586a1.45,1.45,0,1,1,2.9,0v29.031a1.446,1.446,0,0,1-1.45,1.45Z",
    transform: "translate(-193.957 -387.914)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveTheThumbsUp8);
export default __webpack_public_path__ + "static/media/give-the-thumbs-up-8.98ead86403e841a21d68877f4cf7b8d0.svg";
export { ForwardRef as ReactComponent };